import { Heading, P, Stack, useText } from "@sveabank/cc-common";
import { useLocation, useMatches } from "react-router";
import Content from "../components/content";
import Hide from "../components/hide";
import { routeHasHandle } from "../types/route";
import HeadingMobileLayout from "./heading-mobile-layout";

const HeadingLayout = () => {
	const matches = useMatches();
	const location = useLocation();
	const currentRoute = matches.find((match) => match.pathname === location.pathname);
	const [t] = useText();

	const hasHandle = currentRoute && routeHasHandle(currentRoute);

	const heading = hasHandle ? t(currentRoute.handle.heading) : "";

	const subheading = hasHandle
		? currentRoute.handle.subheading && t(currentRoute.handle.subheading)
		: undefined;

	const subheading2 = hasHandle
		? currentRoute.handle.subheading2 && t(currentRoute.handle.subheading2)
		: undefined;

	return (
		<>
			<Hide from="tablet">
				<HeadingMobileLayout heading={heading} subHeading={subheading} />
			</Hide>

			<Hide to="tablet">
				<section className="bg-background-dark tablet:block hidden text-center">
					<Content size={8} py={8}>
						<Stack gap={4}>
							<Heading.H1 size="h2" className="text-text-contrast">
								{heading}
							</Heading.H1>
							<Stack>
								{!!subheading && <P className="text-text-contrast">{subheading}</P>}
								{!!subheading2 && <P className="text-text-contrast">{subheading2}</P>}
							</Stack>
						</Stack>
					</Content>
				</section>
			</Hide>
		</>
	);
};

export default HeadingLayout;
